import React, { useState, useEffect, useMemo } from "react"
import { useStore } from "../../teafuljs/store"
import { get, set, del, keys } from "idb-keyval"
import { navigate } from "gatsby"
import { getBible, getDocument } from "../../apis/firebase"
import IconButton from "@material-ui/core/IconButton"
import InsertChartOutlined from "@material-ui/icons/InsertChartOutlined"

import { makeStyles } from "@material-ui/core/styles"
import {
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  Divider,
  FormGroup,
  FormControlLabel,
  Switch,
  Popover,
  Avatar,
} from "@material-ui/core"
import { Home, Help } from "@material-ui/icons"
import LanguageSelect from "../Select/LanguageSelect"
import VersionSelect from "../Select/VersionSelect"
import KeyPassageSelect from "../AutoComplete/KeyPassageSelect"
import ValuesSelect from "../AutoComplete/ValuesSelect"
import SVReaderLogo from "../../../static/images/SVLogo.jpeg"
import SphereViewLogo from "../../../static/images/SphereViewCarousel.png"
import { getTranslation } from "../../scripts/getTranslation"
import { recordEvent } from "../../apis/googleAnalytics"
import FormDialog from "../Dialogs/FormDialog"
import YWAMLogo from "./../../../static/images/YWAMLogo.png"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    height: "100%",
    maxWidth: 300,
    backgroundColor: theme.palette.background.paper,
    overflowY: "auto",
  },
  avatar: {
    marginRight: 10,
    width: 40
  },
  homeIcon: {
    left: 0,
  },
  LanguageSelects: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    "& child": {
      margin: "2px",
    },
  },
  keyPassages: {
    display: "flex",
    justifyContent: "space-between",
    "& child": {
      margin: "2px",
    },
  },
  sphereSwitch: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  downloaded: {
    fontStyle: "italic",
    color: "grey",
  },
  offline: {
    marginTop: "10px",
    display: "flex",
    justifyContent: "space-between",
    verticalAlign: "middle",
    padding: "2px",
    position: "relative",
    width: "100%",
  },
  popover: {
    textAlign: "center",
    maxWidth: "80vw",
  },
  popoverText: {
    padding: "20px",
    position: "relative",
    width: "100%",
    fontWeight: "bold",
  },
  options: {
    display: "flex",
    justifyContent: "space-around",
    padding: "20px",
  },
  selectHolder: {
    position: "relative",
    width: "100%",
  },
  logo: {
    position: "relative",
    height: "auto",
    width: "30px",
    margin: "auto 0",
  },
  loader: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  sphereViewLink: {
    fontWeight: "bold",
  }
}))

const Menu = props => {
  const translations = useStore.translations()[0]
  const AvailableContent = useStore.AvailableContent()[0]
  const stateLanguage = useStore.language()[0]
  const stateVersion = useStore.version()[0]
  const [history, setHistory] = useStore.history()
  const [searchID, setSearchID] = useStore.searchID()
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID()
  const [showSpheres, setShowSpheres] = useStore.showSpheres();
  const [showValues, setShowValues] = useStore.showValues();
  const [interlinear, setInterlinear] = useStore.interlinear();
  const [currentBook, setCurrentBook] = useStore.currentBook();
  const classes = useStyles()
  const [deleting, updateDeleting] = useState(false)
  const [downloaded, updateDownloaded] = useState(false)
  const [updateAvailable, setUpdateAvailable] = useState(false)
  const [downloadable, setDownloadable] = useState(
    AvailableContent
      ? AvailableContent.content[stateLanguage].versions[stateVersion]
          .downloadable
      : false
  )
  const [downloading, setDownloading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [segmentSaved, setSegmentSaved] = useState()
  const [openFormDialog, setOpenFormDialog] = useState(false)

  useEffect(() => {
    setDownloadable(
      AvailableContent
        ? AvailableContent.content[stateLanguage].versions[stateVersion]
            .downloadable
        : false
    )
  }, [stateLanguage, stateVersion, AvailableContent])

  function isDownloaded() {
    const key = `${stateLanguage}-${stateVersion}-version`
    get(key).then(val => {
      if (val !== undefined) {
        if (
          AvailableContent.content[stateLanguage].versions[stateVersion]
            .version !== val
        ) {
          setUpdateAvailable(true)
        }
        if (!downloaded) {
          updateDownloaded(true)
        }
        return true
      } else {
        if (downloaded) {
          updateDownloaded(false)
        }
        return false
      }
    })
  }
  isDownloaded()

  //PopOver Layers toggling open and closed
  const [deleteDBPopup, updateDeleteDBPopup] = useState(false)

  function handleDeleteClick() {
    updateDeleteDBPopup(true)
  }

  function deleteDBHandleClose() {
    updateDeleteDBPopup(false)
  }

  const deleteDBOpen = Boolean(deleteDBPopup)
  const deleteDBId = deleteDBOpen ? "simple-popover" : undefined

  async function downloadToDB(language, version) {
    setDownloading(true)
    const fullBible = await getBible(stateLanguage, stateVersion)
      .catch(e => {
        alert(
          getTranslation(
            translations,
            stateLanguage,
            "UI",
            "menu_download_error"
          ),
          e
        )
      })
    setSaving(true)
    const segIDs = Object.keys(fullBible)
    segIDs.forEach(async seg => {
      const key = `${language}-${version}-${seg}`
      await set(key, fullBible[seg])
        .then(() => {
          console.log("seg", seg)
          setSegmentSaved(seg)
        })
        .catch(err => alert(`Saving error: ${err}`))
    })
    await set(
      `${language}-${version}-version`,
      AvailableContent.content[stateLanguage].versions[stateVersion].version
    ).catch(err => alert(err))
    updateDownloaded(true)
    setSaving(false)
    setDownloading(false)
    setDownloading(false)
    }


  async function downloadVersion() {
    await downloadToDB(stateLanguage, stateVersion)
      .then(() => {
        recordEvent("Downloaded Bible", `${stateLanguage}-${stateVersion}`)
        updateDownloaded(true)
        setUpdateAvailable(false)
        updateDeleteDBPopup(false)
      })
      .catch(err => alert(err))
  }

  // update to new idb key value package format
  async function deleteVersion() {
    updateDeleting(true)
    await keys().then(keys => {
      keys.forEach(key => {
        if (key.substring(0, 7) === `${stateLanguage}-${stateVersion}`) {
          del(key)
        }
      })
    })
    recordEvent("Removed Bible", `${stateLanguage}-${stateVersion}`)
    updateDownloaded(false)
    updateDeleteDBPopup(false)
    updateDeleting(false)
  }

  const percentageSaved = useMemo(() => {
    if (!segmentSaved) return 0
    if (segmentSaved[0] === "I") {
      return Math.round((+segmentSaved.substring(2, 4) / (66 + 365)) * 100)
    }
    if (segmentSaved[0] === "S") {
      return Math.round(
        ((+segmentSaved.substring(1, 4) + 66) / (66 + 365)) * 100
      )
    }
  }, [segmentSaved])

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="Main mailbox folders">
        <ListItem
          onClick={() => {
            setHistory([
              {
                page: window.location.pathname,
                language: stateLanguage,
                version: stateVersion,
                segment: currentSegmentID,
                scrollY: window.scrollY,
              },
              ...history,
            ])
            navigate("/")
            props.closeMenu()
          }}
        >
          {/* <Avatar
            alt="Remy Sharp"
            src={SVReaderLogo}
            className={classes.avatar}
          /> */}
          <ListItemIcon className={classes.homeIcon}>
            <Home />
          </ListItemIcon>
          <ListItemText
            primary={`${getTranslation(
              translations,
              stateLanguage,
              "UI",
              "home_title1"
            )} ${getTranslation(
              translations,
              stateLanguage,
              "UI",
              "home_title2"
            )}`}
          />
        </ListItem>
        <Divider />
        <ListItem className={classes.LanguageSelects}>
          <div className={classes.selectHolder}>
            <LanguageSelect location={props.location} />
          </div>
          <div className={classes.selectHolder}>
            <VersionSelect location={props.location} />
          </div>
          <div className={classes.offline}>
            {downloading && !saving && (
              <div className={classes.loader}>
                <LoadingSpinner />
                <Typography className={classes.downloaded}>
                  {getTranslation(
                    translations,
                    stateLanguage,
                    "UI",
                    "menu_downloading"
                  )}
                  ...
                </Typography>
              </div>
            )}
            {downloading && saving && (
              <div className={classes.loader}>
                <LoadingSpinner />
                <Typography className={classes.downloaded}>
                  {getTranslation(
                    translations,
                    stateLanguage,
                    "UI",
                    "menu_saving"
                  )}
                  ...
                  {`${
                    percentageSaved === 0
                      ? "please wait"
                      : `(${percentageSaved}%)`
                  }`}
                </Typography>
              </div>
            )}
            {(!downloaded || updateAvailable) &&
            downloadable &&
            !downloading ? (
              <Button
                color="secondary"
                size="small"
                variant="contained"
                onClick={() => downloadVersion()}
              >
                {updateAvailable
                  ? getTranslation(
                      translations,
                      stateLanguage,
                      "UI",
                      "menu_update"
                    )
                  : getTranslation(
                      translations,
                      stateLanguage,
                      "UI",
                      "menu_download"
                    )}
              </Button>
            ) : null}
            {downloaded && downloadable && !downloading ? (
              <React.Fragment>
                {!updateAvailable && (
                  <Typography className={classes.downloaded}>
                    {getTranslation(
                      translations,
                      stateLanguage,
                      "UI",
                      "menu_downloaded"
                    )}
                  </Typography>
                )}
                <Button
                  color="secondary"
                  size="small"
                  variant="outlined"
                  onClick={() => handleDeleteClick()}
                >
                  {getTranslation(
                    translations,
                    stateLanguage,
                    "UI",
                    "menu_remove_download"
                  )}
                </Button>
                <Popover
                  className={classes.popover}
                  id={deleteDBId}
                  open={deleteDBOpen}
                  anchorEl={deleteDBPopup}
                  onClose={deleteDBHandleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                >
                  {!deleting ? (
                    <React.Fragment>
                      <Typography className={classes.popoverText}>
                        {getTranslation(
                          translations,
                          stateLanguage,
                          "UI",
                          "menu_remove_download_question"
                        )}
                      </Typography>
                      <div className={classes.options}>
                        <Button
                          color="secondary"
                          size="small"
                          variant="outlined"
                          onClick={() => deleteDBHandleClose()}
                        >
                          {getTranslation(
                            translations,
                            stateLanguage,
                            "UI",
                            "menu_cancel"
                          )}
                        </Button>
                        <Button
                          color="primary"
                          size="small"
                          variant="contained"
                          onClick={() => deleteVersion()}
                        >
                          {getTranslation(
                            translations,
                            stateLanguage,
                            "UI",
                            "menu_remove_download"
                          )}
                        </Button>
                      </div>
                    </React.Fragment>
                  ) : (
                    <Typography className={classes.popoverText}>
                      {getTranslation(
                        translations,
                        stateLanguage,
                        "UI",
                        "menu_remove_download_response"
                      )}
                    </Typography>
                  )}
                </Popover>
              </React.Fragment>
            ) : null}
          </div>
        </ListItem>
        <Divider />
        <ListItem
          onClick={() => {
            setHistory([
              {
                page: window.location.pathname,
                language: stateLanguage,
                version: stateVersion,
                segment: currentSegmentID,
                scrollY: window.scrollY,
              },
              ...history,
            ])
            navigate("/sourceView")
            props.closeMenu()
          }}
        >
          <Avatar
            alt="Remy Sharp"
            src={SVReaderLogo}
            className={classes.avatar}
          />
          <ListItemText
            className={classes.sphereViewLink}
            primary={`${getTranslation(
              translations,
              stateLanguage,
              "UI",
              "home_title1"
            )}`}
          />
        </ListItem>
        {AvailableContent.content[stateLanguage].versions[stateVersion]
          .layers &&
        AvailableContent.content[stateLanguage].versions[
          stateVersion
        ].layers.indexOf("spheres") !== -1 ? (
          <React.Fragment>
            <Divider />
            <ListItem
              onClick={() => {
                setHistory([
                  {
                    page: window.location.pathname,
                    language: stateLanguage,
                    version: stateVersion,
                    segment: currentSegmentID,
                    scrollY: window.scrollY,
                  },
                  ...history,
                ])
                navigate("/sphereView")
                props.closeMenu()
              }}
            >
              <Avatar
                alt="Remy Sharp"
                src={SphereViewLogo}
                className={classes.avatar}
              />
              <ListItemText
                className={classes.sphereViewLink}
                primary={`${getTranslation(
                  translations,
                  stateLanguage,
                  "UI",
                  "layers_sphereview"
                )}`}
              />
            </ListItem>
            <ListItem className={classes.keyPassages}>
              <FormGroup row className={classes.sphereSwitch}>
                <FormControlLabel
                  label={getTranslation(
                    translations,
                    stateLanguage,
                    "UI",
                    "menu_sphere_key_passages"
                  )}
                  labelPlacement="start"
                  control={
                    <Switch
                      checked={showSpheres}
                      onChange={() => {
                        setShowSpheres(!showSpheres)
                      }}
                      value={showSpheres}
                    />
                  }
                />
              </FormGroup>
            </ListItem>
            {showSpheres ? (
              <ListItem>
                <KeyPassageSelect
                  location={props.location}
                  closeMenu={props.closeMenu}
                />
              </ListItem>
            ) : null}
          </React.Fragment>
        ) : null}
        <Divider />
        <ListItem
          onClick={() => {
            setHistory([
              {
                page: window.location.pathname,
                language: stateLanguage,
                version: stateVersion,
                segment: currentSegmentID,
                scrollY: window.scrollY,
              },
              ...history,
            ])
            navigate("/dataCharts")
            props.closeMenu()
          }}
        >
          <InsertChartOutlined className={classes.avatar} />
          <ListItemText
            className={classes.sphereViewLink}
            primary={`${getTranslation(
              translations,
              stateLanguage,
              "UI",
              "data_charts"
            )}`}
          />
        </ListItem>
        {AvailableContent.content[stateLanguage].versions[stateVersion]
          .layers &&
        AvailableContent.content[stateLanguage].versions[
          stateVersion
        ].layers.indexOf("values") !== -1 ? (
          <React.Fragment>
            <Divider />
            <ListItem className={classes.keyPassages}>
              <img src={YWAMLogo} className={classes.logo} alt="YWAM Logo" />
              <FormGroup row className={classes.sphereSwitch}>
                <FormControlLabel
                  label={getTranslation(
                    translations,
                    stateLanguage,
                    "UI",
                    "menu_value_value_passages"
                  )}
                  labelPlacement="start"
                  control={
                    <Switch
                      checked={showValues}
                      onChange={() => {
                        setShowValues(!showValues)
                      }}
                      value={showValues}
                    />
                  }
                />
              </FormGroup>
            </ListItem>
            {showValues ? (
              <ListItem>
                <ValuesSelect
                  location={props.location}
                  closeMenu={props.closeMenu}
                />
              </ListItem>
            ) : null}
          </React.Fragment>
        ) : null}
        <Divider />
        <ListItem onClick={() => setOpenFormDialog(true)}>
          <ListItemText primary="Want this tool in your language?" />
          <ListItemIcon className={classes.homeIcon}>
            <Help />
          </ListItemIcon>
        </ListItem>
      </List>
      {openFormDialog && (
        <FormDialog open={openFormDialog} close={setOpenFormDialog} />
      )}
    </div>
  )
}

export default Menu
